// @ts-ignore
import emitter from 'tiny-emitter/instance';
import type { ICMMenuExpandedComponent } from './types';

// eslint-disable-next-line no-unused-vars
type emitterType = (eventName: string, ...args: any[]) => void;
type nextIdType = number;

interface ICMEventHubInterface {
  nextId: nextIdType;
  getId: () => nextIdType;
  $on: emitterType;
  $once: emitterType;
  $off: emitterType;
  $emit: emitterType;
}

export const ICMEventHub: ICMEventHubInterface = {
  nextId: 1,
  getId() {
    return this.nextId++;
  },
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args),
};

type exapndItemArgumentsType = ICMMenuExpandedComponent | undefined;

export const exapndItem = (item: exapndItemArgumentsType): void => {
  const chainedIds: number[] = [];
  const initiateChainedIds = (ref: exapndItemArgumentsType, activeIds: number[]): number[] => {
    if (!ref) return activeIds;

    const root = 'ICMMenu';
    const expandableComponents = ['ICMMenuSubmenu', 'ICMMenu'];
    const currentComponent: string | undefined = ref.$options.name;
    if (expandableComponents.includes(currentComponent as string)) activeIds.push(ref.id || ref?.$data.id);
    if (currentComponent === root) return activeIds;
    return initiateChainedIds(ref.$parent as ICMMenuExpandedComponent, activeIds);
  };
  initiateChainedIds(item, chainedIds);
  return ICMEventHub.$emit('submenuMouseover', chainedIds);
};
